import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { profileApi } from '@/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: JSON.parse(localStorage.getItem('admin_user') || 'null'),
    token: localStorage.getItem('admin_token') || '',
    nickname: '',
    avatar: ''
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user
    },
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('admin_token', token)
    },
    SET_PROFILE(state, { nickname, avatar }) {
      state.nickname = nickname
      state.avatar = avatar
    },
    LOGOUT(state) {
      state.user = null
      state.token = ''
      state.nickname = ''
      state.avatar = ''
      localStorage.removeItem('admin_token')
      localStorage.removeItem('admin_user')
    }
  },
  actions: {
    login({ commit }, credentials) {
      return axios.post('/api/admin/login', credentials).then(res => {
        const data = res.data
        if (data.code !== 200) {
          return Promise.reject(new Error(data.message || '登录失败'))
        }
        const { token, username, role, tenant_id, tenant_name } = data.data
        commit('SET_TOKEN', token)
        const user = { username, role, tenant_id, tenant_name }
        commit('SET_USER', user)
        localStorage.setItem('admin_user', JSON.stringify(user))
        return Promise.resolve()
      }).catch(err => {
        if (err.response && err.response.data) {
          return Promise.reject(new Error(err.response.data.message || '登录失败'))
        }
        return Promise.reject(new Error('网络错误，请检查后端服务是否启动'))
      })
    },
    fetchProfile({ commit }) {
      return profileApi.me().then(res => {
        const { nickname, avatar } = res.data
        commit('SET_PROFILE', { nickname: nickname || '', avatar: avatar || '' })
        // 同步更新 localStorage 中 admin_user 的 nickname/avatar
        const user = JSON.parse(localStorage.getItem('admin_user') || 'null')
        if (user) {
          user.nickname = nickname || ''
          user.avatar = avatar || ''
          localStorage.setItem('admin_user', JSON.stringify(user))
        }
        return Promise.resolve()
      }).catch(() => {
        // 静默失败，不影响主流程
        return Promise.resolve()
      })
    }
  }
})
